import { useStore } from '../store';
const { is_mobile } = useStore();

function urlmap(url) {
    return url_root.substr(0, url_root.length - 1) + url;
}


function tab(triggers, contents, trigger_on_class_name, content_on_class_name) {
    content_on_class_name = content_on_class_name || trigger_on_class_name;
    for (i in triggers) {
        function switch_tab(idx) {
            return function (e) {
                for (j in triggers) {
                    if (j == idx) {
                        $(contents[j]).addClass(content_on_class_name);
                        $(triggers[j]).addClass(trigger_on_class_name);
                        $(contents[j]).css({ "display": "" });
                    } else {
                        $(contents[j]).removeClass(content_on_class_name);
                        $(triggers[j]).removeClass(trigger_on_class_name);
                        $(contents[j]).css({ "display": "none" });
                    }
                }
            };
        }
        $(triggers[i]).bind("click", switch_tab(i));
    }
}

function peek(obj) {
    var s = "";
    for (var key in obj) {
        s += "" + key + " = " + obj[key] + "<br/>";
    }
    $("#log").html(s);
}

function shallow_copy(obj) {
    var new_obj = {};
    for (var p in obj) {
        new_obj[p] = obj[p];
    }
    return new_obj;
}


function split_with_capture(s, pattern) {
    // for ie6 compatibility
    var segs = [];
    while (1) {
        var m = pattern.exec(s);
        if (!m) {
            segs.push(s);
            break;
        }
        segs.push(s.substr(0, m.index));
        for (var i = 1; i < m.length; i++) {
            segs.push(m[i]);
        }
        s = s.substr(m.index + m[0].length);
    }
    return segs;
}



function text2html(text, root, cfg) {
    console.log("text2html", is_mobile.value);
    if (!text) {
        return
    }
    let percentFornt_w = is_mobile.value ? 1.93 : 8;
    let percentFornt_u = is_mobile.value ? 'vw' : 'px';
    let all_tag = null;
    let mingke_list = null;
    let last_tag = null;
    let level_list_str = null;
    let level_list = null;
    let show_tag = null;

    let show_text = null;
    let last1_tag = null;
    let last2_tag = null;
    let pngimage_list = null;
    let altpngimage_list = null;

    root.innerHTML = '';
    cfg = cfg || {};
    // translating tx3 texts to html
    var p = /#([RGBYPWsbuhnr]|c[0-9A-Za-z]{6}|[0-9]{1,3}|wing[0-9]{1,3})/;
    //var segs = text.split(p);
    var segs = split_with_capture(text, p);
    // console.log("segs",segs, text);
    var colors = {
        "R": "red",
        "G": "green",
        "B": "blue",
        "Y": "yellow",
        "P": "pink",
        "W": "white",
        "K": "black"
    };
    // console.log("segs",segs, text, p);
    var seg_config = {};
    var data = [];
    for (var i = 0; i < segs.length; i++) {
        if ((i & 1) == 0) {
            if (segs[i] === undefined) {
                continue
            }
            if (segs[i].indexOf('加护值') != -1) {
                if (segs[i].indexOf('^') != -1) {
                    // console.log("segs-ii", segs[i],i)
                    seg_config['jiahuzhi'] = segs[i];
                    data.push([shallow_copy(seg_config), '']);
                    delete seg_config.jiahuzhi;
                    //alert(segs[i]);
                }
            } else if (segs[i].indexOf('^83') != -1) {
                continue;
            } else if (segs[i].indexOf('临时加护') != -1) {
                if (segs[i].indexOf('^') != -1) {
                    seg_config['linshijiahu'] = segs[i];
                    data.push([shallow_copy(seg_config), '']);
                    delete seg_config.linshijiahu;
                }

            } else if (segs[i].indexOf('炼护值') != -1) {
                if (segs[i].indexOf('^') != -1) {
                    seg_config['lianhuzhi'] = segs[i];
                    data.push([shallow_copy(seg_config), '']);
                    delete seg_config.lianhuzhi;
                    //alert(segs[i]);
                } else {
                    segs[i] = segs[i].replace('#w(7)', '');
                    segs[i] = segs[i].replace('#w(0)', '');
                    data.push([shallow_copy(seg_config), segs[i]]);
                }
            } else if (segs[i].match(/mingke\/\d+.wap/)) {
                //console.log("test");
                mingke_list = segs[i].match(/mingke\/\d+.wap/);
                //console.log(mingke_str);
                seg_config['mingke_stone'] = parseInt(mingke_list[0].replace('mingke/', '').replace('.wap', ''), 10);
                //seg_config['mingke_stone'] = 49276;
                level_list_str = segs[i].match(/mingke\/[a-z]+.wap/g);
                level_list = []
                if (level_list_str) {
                    for (var mingke_index = 0; mingke_index < level_list_str.length; mingke_index++) {
                        level_list.push(level_list_str[mingke_index].replace("mingke/", "").replace(".wap", ""));
                    }
                }
                data.push([shallow_copy(seg_config), level_list]);
                delete seg_config.mingke_stone;
            } else if (segs[i].match(/item\/equip_smelt\/\S+\.png/g)) {
                pngimage_list = segs[i].match(/item\/equip_smelt\/\S+\.png/g);
                seg_config['pngimage'] = 'pngimage';
                data.push([shallow_copy(seg_config), pngimage_list]);
                delete seg_config.pngimage;
            } else if (segs[i].match(/common\/\S+\.png/g)) {
                altpngimage_list = segs[i].match(/common\/\S+\.png/g);
                seg_config['altpngimage'] = 'altpngimage';
                data.push([shallow_copy(seg_config), altpngimage_list]);
                delete seg_config.altpngimage;
            } else if (segs[i].indexOf('mingke/INV_1.wap') != -1) {
                seg_config['mingke_mr'] = 'baoshi_mr';
                level_list_str = segs[i].match(/mingke\/[a-z]+.wap/g);
                level_list = []
                if (level_list_str) {
                    for (var mingke_index = 0; mingke_index < level_list_str.length; mingke_index++) {
                        level_list.push(level_list_str[mingke_index].replace("mingke/", "").replace(".wap", ""));
                    }
                }
                data.push([shallow_copy(seg_config), level_list]);
                delete seg_config.mingke_mr;
            }
            else {
                data.push([shallow_copy(seg_config), segs[i]]);
                // console.log("segs-------",segs[i], seg_config);
            }
            continue;
        }

        // matches
        if (segs[i] in colors) {
            seg_config["color"] = segs[i];
        } else if (segs[i].charAt(0) == "c") {
            seg_config["color"] = "#" + segs[i].substr(1);
        } else if (segs[i] == "s") {
            seg_config["shake"] = true;
        } else if (segs[i] == "b") {
            seg_config["blink"] = true;
        } else if (segs[i] == "u") {
            seg_config["underline"] = true;
        } else if (segs[i] == "h") {
            seg_config["hide"] = true;
        } else if (segs[i] == "n") {
            seg_config = {};
        } else if (segs[i] == "r") {
            seg_config["br"] = true;
            data.push([shallow_copy(seg_config), ""]);
            delete seg_config.br;
        } else if (segs[i].match(/^\d+$/)) {
            seg_config["img"] = true;
            data.push([shallow_copy(seg_config), "https://tx3.res.netease.com/qt/12/bang/images/baozi/" + parseInt(segs[i], 10) + ".gif"]);
            delete seg_config.img;
        } else if (segs[i].match(/^wing\d+$/)) {
            //console.log(segs[i])
            seg_config["img"] = true;
            data.push([shallow_copy(seg_config), "https://tx3.res.netease.com/qt/12/bang/images/child/" + parseInt(segs[i].replace('wing', ''), 10) + ".png"]);
            delete seg_config.img;
        } else if (segs[i].match(/mingke[a-z]+.wap/)) {
            level_arr = segs[i].match(/mingke[a-z]+.wap/);
            level_list = [];
            for (var mingke_index = 0; mingke_index < level_arr.length; mingke_index++) {
                level_list.append(level_arr[mingke_index].replace("mingke", "").replace(".wap", ""));
            }
            seg_config["mingke_level"] = level_list;
            delete seg_config.mingke_level;
        }

    }
    //console.log(data);
    var previous_contains_new_line = true; // whether previous newline-and-empty block contains new line?
    for (var i = 0; i < data.length; i++) {
        var seg_config = data[i][0];
        var seg = data[i][1];
        // console.log("DEBUG:",seg, data[i]);
        if (seg_config["br"]) {
            if (cfg["compact"] && previous_contains_new_line) {
                continue;
            }
            var br = document.createElement("br");
            root.appendChild(br);
            previous_contains_new_line = true;
        } else if (seg_config["img"]) {
            var img = document.createElement("img");
            // better images?
            img.src = seg;
            if (seg.match('tx3.res.netease.com/qt/12/bang/images/child/')) {
                img.className = 'wing-img';
            }
            root.appendChild(img);
            previous_contains_new_line = false;
        } else if (seg_config['pngimage']) {
            var position_num = root.getAttribute('data-custom')
            var br = document.createElement('br');
            root.appendChild(br);
            const span = document.createElement('span');
            seg.forEach(s => {
                span.className = 'write show-rongzhu';
                span.setAttribute('data-rongzhu', position_num);
                const img = document.createElement('img');
                if (s.includes('tx3.res.netease.com/qt/12/bang/images/child/')) {
                    img.className = 'wing-img';
                }
                // console.log('s', s)
                img.src = `https://tx3.res.netease.com/pc/qt/20151231153005/data/rongzhu/${s.split('/')[2]}`
                span.appendChild(img);
            })
            root.appendChild(span)
            previous_contains_new_line = true;
        } else if (seg_config['altpngimage']) {
            // var br = document.createElement('br');
            // var position_num = root.getAttribute('data-custom')
            // if (position_num === null){
            //     continue
            // }
            // root.appendChild(br);
            // seg.forEach(s => {
            //     const span = document.createElement('span');
            //     span.className = 'write rongzhu';
            //     span.setAttribute('data-rongzhu', position_num);
            //     root.appendChild(span);
            //     const img = document.createElement('img');
            //     if (s.includes('tx3.res.netease.com/qt/12/bang/images/child/')) {
            //         img.className = 'wing-img';
            //     }
            //     img.src = `https://cbg-tainxia2.res.netease.com/game_res/${s}`
            //     span.appendChild(img);
            //     var textNode = document.createTextNode('查看详情');
            //     span.appendChild(textNode);
            // })
            continue
        } else if (seg_config["linshijiahu"]) {
            seg = seg_config["linshijiahu"];
            var linshijiahu_div = document.createElement("div");
            // show_text = '<span class="jiaHuZhi">临时加护:</span>' +
            //     '<span class="percentFornt2" style="width:' + 3 * percentFornt_w + 'vw"></span></p>' +
            //     '<br/>';
            show_text = `<span class="jiaHuZhi">临时加护:</span> <span class="percentFornt2" style="width:${3 * percentFornt_w}${percentFornt_u}"></span></p> <br/>`;
            $(linshijiahu_div).html(show_text);
            $(linshijiahu_div).attr('class', 'jhz-box');
            root.appendChild(linshijiahu_div);

        } else if (seg_config["jiahuzhi"]) {
            seg = seg_config["jiahuzhi"];
            all_tag = seg.split("^").length - 1;
            last_tag = seg.split("^84").length - 1;
            show_tag = all_tag - last_tag;

            var jiahu_div = document.createElement("div");
            // show_text = '<span class="jiaHuZhi">加护值:</span>' +
            //     '<p class="percentBg" style="width:' + all_tag * percentFornt_w + 'vw">' +
            //     '<span class="percentFornt" style="width:' + show_tag * percentFornt_w + 'vw"></span></p>' +
            //     '<br/>';
            show_text = `<span class="jiaHuZhi">加护值:</span> <p class="percentBg" style="width:${all_tag * percentFornt_w}${percentFornt_u}">
                        <span class="percentFornt" style="width:${show_tag * percentFornt_w}${percentFornt_u}"></span></p> <br/>`;
            $(jiahu_div).html(show_text);
            $(jiahu_div).attr('class', 'jhz-box');
            root.appendChild(jiahu_div);

        } else if (seg_config["lianhuzhi"]) {
            seg = seg_config["lianhuzhi"];
            all_tag = seg.split("^").length - 1;
            last1_tag = seg.split("^92").length - 1;
            last2_tag = seg.split("^93").length - 1;
            last_tag = last1_tag + last2_tag;
            show_tag = all_tag - last_tag;

            var lianhu_div = document.createElement("div");
            // show_text = '<span class="jiaHuZhi">炼护值:</span>' +
            //     '<p class="percentBg" style="width:' + all_tag * percentFornt_w + 'vw">' +
            //     '<span class="percentFornt" style="width:' + show_tag * percentFornt_w + 'vw"></span></p>' +
            //     '<br/>';
            show_text = `<span class="jiaHuZhi">炼护值:</span> <p class="percentBg" style="width:${all_tag * percentFornt_w}${percentFornt_u}">
                        <span class="percentFornt" style="width:${show_tag * percentFornt_w}${percentFornt_u}"></span></p> <br/>`;
            $(lianhu_div).html(show_text);
            $(lianhu_div).attr('class', 'lhz-box');
            root.appendChild(lianhu_div);
        } else if (seg_config["mingke_stone"]) {
            seg_index = seg_config["mingke_stone"];
            var i_h = document.createElement("i");
            $(i_h).addClass("img-mingke");
            $(i_h).attr("style", "background-image:url(https://cbg-tx3.res.netease.com/images/mingke/" + parseInt(seg_index, 10) + ".jpg)")
            root.appendChild(i_h);
            if (seg.length > 0) {
                for (var seg_index = 0; seg_index < seg.length; seg_index++) {
                    var i_h = document.createElement("i");
                    $(i_h).addClass(seg[seg_index]);
                    root.appendChild(i_h);
                }
            }
            previous_contains_new_line = false;
        } else if (seg_config["mingke_mr"]) {
            seg_mr = seg_config["mingke_mr"];
            var i_h = document.createElement("i");
            $(i_h).addClass(seg_mr);
            root.appendChild(i_h);
            if (seg.length > 0) {
                for (var seg_index = 0; seg_index < seg.length; seg_index++) {
                    var i_h = document.createElement("i");
                    $(i_h).addClass(seg[seg_index]);
                    root.appendChild(i_h);
                }
            }
            previous_contains_new_line = false;
        } else if (seg_config["mingke_level"]) {
            seg_list = seg_config["mingke_level"];
            for (var seg_index = 0; seg_index < seg_list.length; seg_index++) {
                var i_h = document.createElement("i");
                $(i_h).addClass(seg_list[seg_index]);
                root.appendChild(i_h);
            }
        } else {
            // texts only
            if (!seg.replace(/ +/g, "")) {
                if (cfg["compact"] && previous_contains_new_line) {
                    continue;
                }
            } else {
                previous_contains_new_line = false;
            }
            var span = document.createElement("span");
            var text = seg.replace(/^#w\(\d+\)\s*/, '');
            $(span).text(text);
            for (var n in seg_config) {
                if (n == "color") {
                    if (!seg_config["hide"]) {
                        // hide will overwrite the color
                        if (seg_config[n].charAt(0) != "#") {
                            //$(span).css({"color": colors[n]});
                            $(span).addClass(colors[seg_config[n]]);
                        } else {
                            $(span).css({ "color": seg_config[n] });
                        }
                    }
                } else {
                    $(span).addClass(n);
                }
            }
            root.appendChild(span);
        }
    }
}


function set_top(target_id) {
    var panel_top = document.getElementById(target_id);
    if (panel_top) {
        var scroll_top = $(panel_top).offset()["top"];
        document.body.scrollTop = scroll_top;
        document.documentElement.scrollTop = scroll_top;
    }
}


function decode_hash(hash) {
    if (hash) {
        hash = hash.substr(1);
    }
    var kvs = hash.split("&");
    var d = {};
    for (var i = 0; i < kvs.length; i++) {
        if (kvs[i]) {
            var kv = kvs[i].split("=");
            d[kv[0]] = decodeURIComponent(kv[1]);
        }
    }
    return d;
}


function encode_hash(d) {
    var hash = [];
    for (var key in d) {
        hash.push(key + "=" + encodeURIComponent(d[key]));
    }
    return hash.join("&");
}


function query(url, data, callback, error_callback) {
    jQuery.ajax({
        "url": urlmap(url),
        "type": "GET",
        "dataType": "json",
        "data": data,
        "error": function (jqXHR, textStatus, errorThrown) {
            //alert("对不起，服务器出错，请稍候再试。");
            error_callback();
        },
        "success": function (ret_data) {
            // set the hash
            var d = decode_hash(window.location.hash);
            for (var i in data) {
                d[i] = data[i];
            }
            // putting back the hash
            window.location.hash = encode_hash(d);
            callback(ret_data);
        }
    });
}


var casc_sel = function (tree, obj_ids, defaults) {
    //function casc_sel(tree, obj_ids, defaults){
    /*
    changes selects according to the specified tree
    tree is a list-represented tree with:
        leaves:
            (1) a string
            (2) a object of {"text": display_text, "value": option_value}
        tree: [leaf_desc(the above), sub-tree]
    obj_ids are a list of selector ids to store the result
    defaults are the initial values, can be unspecified

    example: region and server
    // HTML:
    大区: <select name="region" id="region"></select>
    服务器: <select name="server" id="server"></select>

    // js:
    var servers = [["推荐区", ["服务器1", "服务器2"]], ["小区", ["服务器1", "服务器2"]]];
    $(document).ready(function(){
        casc_sel(servers, ["region", "server"], ["小区", "服务器2"]);
    });
    */
    var default_values = defaults || [];
    function set_defaults(defaults) {
        default_values = defaults;
    }
    function decode_node(node) {
        var desc;
        var text;
        var value;
        var children;
        if (node instanceof Array) {
            desc = node[0];
            children = node[1];
        } else {
            desc = node;
            children = [];
        }
        if (typeof (desc) === "string") {
            text = desc;
            value = desc;
        } else {
            text = desc["text"];
            value = desc["value"];
        }
        return {
            "text": text,
            "value": value,
            "children": children
        };
    }
    function initialize() {
        function select(obj, value) {
            function try_to_select() {
                try {
                    obj.val(value);
                } catch (err) {
                    setTimeout(try_to_select, 30);
                }
            }
            try_to_select();
        }
        function update_tree(objs, values, children) {
            // selects the value of root and update the children
            if (!objs) {
                return;
            }
            if (values[0] !== undefined) {
                select(objs[0], values[0]);
            }
            // advance to the children
            if (!children.length) {
                for (var i = 1; i < objs.length; i++) {
                    objs[i].hide();
                }
                return;
            }
            //objs[1].show();
            var chosen_children = [];
            objs[1].children().remove();
            var value1 = values[1];
            for (var i = 0; i < children.length; i++) {
                var node = document.createElement("option");
                var node_desc = decode_node(children[i]);
                if (i === 0 && (value1 === undefined || value1 === null)) {
                    value1 = node_desc.value;
                }
                $(node).val(node_desc.value).append(document.createTextNode(node_desc.text.replace(/x$/, "")));
                objs[1].append(node);
                if (value1 == node_desc.value) {
                    chosen_children = node_desc.children;
                }
            }
            update_tree(objs.slice(1), values.slice(1), chosen_children);
        }
        // create root
        var root = document.createElement("select");
        $("body").append(root);
        $(root).css({ "display": "none" });
        var objs = [$(root)];
        for (var i = 0; i < obj_ids.length; i++) {
            objs.push($("#" + obj_ids[i]));
        }
        update_tree(objs, [""].concat(default_values), tree);

        objs = objs.slice(1);

        var dealer = function (selected_idx) {
            return function (e) {
                var t = tree;
                for (var i = 0; i < objs.length; i++) {
                    // find the children first
                    var value = objs[i].val();
                    for (var j = 0; j < t.length; j++) {
                        var node = decode_node(t[j]);
                        if (value == node.value) {
                            t = node.children;
                            break;
                        }
                    }
                    if (i == selected_idx) {
                        // setting the rest
                        update_tree(objs.slice(i), [objs[i].val()], t);
                        objs[i].css({ "width": "auto" });
                        break;
                    }
                    objs[i].css({ "width": "auto" });
                }
            };
        };
        for (var i = 0; i < objs.length; i++) {
            objs[i].change(dealer(i));
            objs[i].css({ "width": "auto" });
        }
    }
    return {
        decode_node: decode_node,
        initialize: initialize,
        set_defaults: set_defaults
    };
};



export {
    text2html
};